import { useState } from 'react'
import type { OrgItem } from '@/lib/apiTypes'
import { api } from '@/lib/api'
import { DangerConfirmModal } from '@/shared/components/DangerConfirmModal'
import { useToast } from '@/context/ToastContext'

export function LeaveOrgSection({ org }: { org: OrgItem }) {
  const { showToast } = useToast()
  const [showConfirm, setShowConfirm] = useState(false)
  const [busy, setBusy] = useState(false)

  const handleLeave = async () => {
    setBusy(true)
    try {
      await api.delete(`/api/orgs/${org.slug}/leave`)
      showToast('You have left the organisation. Redirecting...', 'success')
      // Hard navigation guarantees a clean org list (the SPA cache keeps last-good
      // data on a failed refetch, which would leave a 403 dead-link behind).
      setTimeout(() => { window.location.href = '/' }, 1500)
    } catch (err) {
      showToast((err as Error).message, 'error')
      setBusy(false)
    }
  }

  return (
    <>
      <button
        className="btn btn-danger btn-sm"
        onClick={() => setShowConfirm(true)}
      >
        Leave organisation
      </button>

      {showConfirm && (
        <DangerConfirmModal
          track="org_leave_confirm"
          title="Leave organisation"
          confirmLabel="Leave organisation"
          message={`Remove yourself from ${org.name}? You'll need to be re-invited to rejoin.`}
          busy={busy}
          onConfirm={handleLeave}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </>
  )
}

